import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "What We Do", href: "/#business" },
  { label: "Government & Corporates", href: "/#who-we-serve" },
  { label: "Leadership", href: "/#leadership" },
  { label: "House of Rudra", href: "/house-of-rudra" },
  { label: "Coal & Mining", href: "/coal-mining" },
  { label: "Contact", href: "/#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <a
          data-testid="brand-logo-link"
          href="#top"
          className="group flex items-center gap-3"
        >
          <div className="flex items-center gap-3">
            <img
              src="/emblem.png"
              alt="Rudra Empire"
              className="h-11 md:h-12 w-auto"
            />
            <div className="hidden sm:block leading-none border-l border-white/10 pl-3">
              <div className="font-display text-sm tracking-[0.24em] text-neutral-100">RUDRA EMPIRE</div>
              <div className="text-[0.55rem] tracking-[0.28em] uppercase text-[#D4AF37] mt-1">Est. 1995</div>
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              href={n.href}
              className="link-gold text-[0.72rem] xl:text-[0.78rem] tracking-[0.16em] uppercase text-neutral-300 whitespace-nowrap"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          data-testid="header-cta-contact"
          href="#contact"
          className="hidden lg:inline-flex items-center gap-2 border border-[#D4AF37]/70 text-[#D4AF37] px-5 py-2.5 text-[0.72rem] tracking-[0.24em] uppercase whitespace-nowrap hover:bg-[#D4AF37] hover:text-black transition-colors duration-300"
        >
          Enquire
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-neutral-100 p-2"
          aria-label="Toggle menu"
        >
          {open ? <X strokeWidth={1.2} /> : <Menu strokeWidth={1.2} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden glass border-t border-white/5">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <a
                key={n.href}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                href={n.href}
                className="text-sm tracking-[0.2em] uppercase text-neutral-300 hover:text-[#D4AF37]"
              >
                {n.label}
              </a>
            ))}
            <a
              data-testid="mobile-cta-contact"
              href="#contact"
              onClick={() => setOpen(false)}
              className="border border-[#D4AF37]/70 text-[#D4AF37] text-center px-5 py-3 text-xs tracking-[0.24em] uppercase"
            >
              Begin Conversation
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
